module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/wristband-h5.48e20474.png";